import React from 'react'
import { Switch } from 'react-router-dom'
import Dashboard from 'Containers/Dashboard'
import EditAgreement from 'Containers/EditAgreement'
import Agreement from 'Containers/Agreement'
import AuthRoute from '../shared/security/AuthRoute/AuthRoute'

const Routes = () => (
  <Switch>
    <AuthRoute exact path="/" component={Dashboard} />
    <AuthRoute path="/oauth/landing" component={Dashboard} />
    <AuthRoute path="/new" component={EditAgreement} />
    <AuthRoute path="/new-proposal" render={props => <EditAgreement {...props} asProposal={true} />} />
    <AuthRoute path="/edit/:id" component={EditAgreement} />
    <AuthRoute path="/edit-proposal/:id" render={props => <EditAgreement {...props} asProposal={true} />} />
    <AuthRoute path="/view/:id" component={Agreement} />
  </Switch>
)

export default Routes



// WEBPACK FOOTER //
// ./src/routes/index.js